import React from 'react';
import MobileMenu from './MobileMenu';
import MegaMenu from './MegaMenu';
import { useSelector } from 'react-redux';

const Navigation = (props) => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);

    if (props.display === 'mobile') {
        return <MobileMenu links={contentLinks} helpDeskUrl={props.helpDeskUrl} addressInformation={props.addressInformation} ChannelsNamesAndUrls={props.channels} configuratorLink={props.configuratorLink} configuratorOpenMode={props.configuratorOpenMode} logo={props.logo} renderMobileItems />;
    } else {
        return <MegaMenu links={contentLinks} helpDeskUrl={props.helpDeskUrl} addressInformation={props.addressInformation} ChannelsNamesAndUrls={props.channels} configuratorLink={props.configuratorLink} configuratorOpenMode={props.configuratorOpenMode} logo={props.logo} startpageurl={props.startpageurl} />;
    }
};

export default Navigation;
